import { dateLocaleFormats } from '@moodys/cre-cpm.constants.formats';
import moment, { Moment } from 'moment';

export const formatDate: (
  value: number | null | undefined,
  locale: string
) => string = (value, locale) => (value ? moment.unix(value).format(dateLocaleFormats[locale]) : '-');

export const remainingDaysFromToday = (dateTimestamp: number): number => {
  const today = moment();
  const dueDate = moment.unix(dateTimestamp);
  return dueDate.diff(today, 'days');
};

export const getDayTimestamp = (date: Moment): number => {
  const currentDate = moment();
  return date.hour(currentDate.hour()).minute(currentDate.minute()).unix();
};
